import fcm from "fcm"
import {
  initMDB,
  Input,
  Tab,
  Collapse,
  Ripple,
  Modal,
  Select,
  Tooltip,
  Chip,
  Dropdown,
  PerfectScrollbar,
  Datepicker,
  Clipboard,
  Sidenav,
  Stepper,
  Carousel,
  Lightbox,
  Popover,
} from "mdb-ui-kit"

console.log("page load")
const MD_BREAKPOINT = 768

document.addEventListener("turbo:load", () => {
  console.log("turbo:load 5")
  initMDB({
    Input,
    Tab,
    Collapse,
    PerfectScrollbar,
    Ripple,
    Modal,
    Select,
    Tooltip,
    Chip,
    Dropdown,
    Datepicker,
    Clipboard,
    Sidenav,
    Stepper,
    Carousel,
    Lightbox,
    Popover,
  })

  document.querySelectorAll("[data-mdb-input-init]").forEach((mdbInput) => {
    // https://mdbootstrap.com/docs/standard/forms/input-fields/#section-dynamic-input-initialization
    new Input(mdbInput).init()
  })

  document.querySelectorAll("[data-mdb-select-init]").forEach((mdbSelect) => {
    // https://mdbootstrap.com/docs/standard/forms/input-fields/#section-dynamic-input-initialization
    //
    // new Select(mdbSelect);
  })

  const scrollSection = document.getElementsByClassName("scroll-section")
  scrollSection.forEach((el) => {
    const ps = new PerfectScrollbar(el, { suppressScrollX: true })
  })

  if (document.querySelector("[name=current-member-profile-id]") != null) {
    $("#request-token-button").on("click", function () {
      console.log("request-token-button")
      fcm.requestToken()
    })
  }

  const observer = new MutationObserver(() => {
    // Get all visible modals
    const visibleModals = Array.from(
      document.querySelectorAll(".modal")
    ).filter((modal) => !modal.classList.contains("d-none"))

    const backdrops = Array.from(document.querySelectorAll(".modal-backdrop"))

    if (visibleModals.length === 0) {
      // No visible modals: remove all backdrops
      backdrops.forEach((backdrop) => {
        backdrop.remove()
        console.log("Removed stray modal-backdrop")

        // Restore body scroll properly
        document.body.classList.remove("modal-open")
        document.body.style.overflow = ""
        document.body.style.position = ""
        document.body.style.width = ""
        document.body.style.paddingRight = ""

        document
          .querySelectorAll(".fixed-top, .fixed-bottom, .sticky-top")
          .forEach((el) => (el.style.paddingRight = ""))
      })
    } else if (visibleModals.length >= 1 && backdrops.length > 1) {
      // More than one backdrop: keep only one
      backdrops.slice(1).forEach((backdrop) => {
        backdrop.remove()
        console.log("Removed extra modal-backdrop, keeping only one")
      })
    }
  })

  // Observe the body for modal/backdrop changes
  observer.observe(document.body, { childList: true, subtree: true })

  console.log("turbo:load 5 finished")
})
